module.exports = __webpack_public_path__ + "img/coin-stack-active.a367b2ff.svg";